// Shared validation for a ?signupSource= query param.
//
// The web-static landing pages live on static.codingal.com while the register
// pages are on www.codingal.com, so the localStorage signup source the on-site
// CTAs write never travels across. Those pages instead forward their own full
// path as ?signupSource=/lp/<page>.html, which the register flows read here.
//
// The value is user-supplied and ends up in the DB, Slack alerts and Blackops,
// and get_booking_source renders it as a link - so validate rather than trust.
// Shape accepted: an absolute path made of the characters our landing page
// filenames actually use, capped well under the 256-char column. The `.html`
// extension is part of the stored value, so dots are allowed - which means the
// pattern also has to rule out '..' and a leading '//' by hand, keeping it a
// single-slash path that cannot walk out of itself or become a protocol-
// relative URL. Anything else returns undefined so callers fall back.
const SIGNUP_SOURCE_QUERY_PARAM_PATTERN = /^\/(?!\/)(?!.*\.\.)[a-zA-Z0-9/_.-]{1,200}$/

export const getValidatedSignupSourceFromQuery = (
  value: string | string[] | undefined
): string | undefined =>
  typeof value === 'string' && SIGNUP_SOURCE_QUERY_PARAM_PATTERN.test(value)
    ? value
    : undefined
